export default {
  common: {
    cancel: "Odustani",
    add: "Dodaj",
    back: "Natrag", 
    next: "Dalje", 
    submit: "Pošalji",
    saving: "Spremanje…",
    saved: "Spremljeno ✓",
  },

  menu: {
    backToDashboard: "Natrag na nadzornu ploču",
    myObjects: "Moji objekti",
    settings: "Postavke",
    help: "Pomoć / Kontakt",
    logout: "Odjava",
    language: "Hrvatski",
  },

  contact: {
    title: "Kontakt",
    subtitle: "Kako vam možemo pomoći?",
    messageLabel: "Vaša poruka",
    send: "Pošalji poruku",
    success: "Poruka je uspješno poslana!",
    close: "Zatvori",
  },

  dashboard: {
    welcome: "Dobrodošli natrag, ",
    overview: "Moj pregled",
    summaryText: "Ovdje možete brzo vidjeti status svojih objekata.",
    activeObjects: "Objekt(i) online",
    inReviewObjects: "Objekt(i) u provjeri",

    contact: "Moji kontakt podaci",
    editContact: "Uredi",

    settings: "Moje postavke",
    subscription: "Pretplata",
    subscriptionActive: "Aktivna",
    password: "Lozinka",
    changePassword: "Promijeni lozinku",

    objects: "Moji objekti",
    objectboxText: "Unos dostupnosti i cijena",
    objectboxText2: "Uredi podatke o objektu",
    objectbuttonText: "Upravljaj objektima",

    newObjectContainer: "Dodaj novi objekt",
    newObjectDescription: "Kreiraj novi objekt ili nastavi ranije započeti unos.",
    continueDraft: "➜ Nastavi unos",
    newObject: "+ Dodaj novi objekt",

    documents: "Dokumenti",
    lastInvoice: "Zadnji račun",
    openArchive: "Otvori arhiv",
  },

  contactEdit: {
    title: "Uredi kontakt podatke",
    errorLoading: "Greška pri učitavanju podataka.",
    errorSaving: "Greška pri spremanju podataka.",
    confirmLeave: "Želite li spremiti promjene?",
    salutation: "Titula",
    selectSalutation: "Odaberite titulu",
    company: "Tvrtka",
    firstName: "Ime",
    lastName: "Prezime",
    street: "Ulica",
    houseNumber: "Kućni broj",
    postalCode: "Poštanski broj",
    town: "Grad / Mjesto",
    country: "Država",
    selectCountry: "Odaberite državu",
    phone: "Telefonski broj",
    cancel: "Odustani",
    save: "Spremi",
    requiredFields: "Molimo ispunite sva obavezna polja.",
  },

  registerUser: {
    title: "Kontakt podaci",
    verifiedMessage:
      "Vaša e-mail adresa je uspješno potvrđena. Sada unesite svoje kontakt podatke.",

    salutation: "Titula",
    selectSalutation: "Odaberite titulu",
    company: "Tvrtka (opcionalno)",
    firstName: "Ime",
    lastName: "Prezime",
    street: "Ulica",
    houseNumber: "Kućni broj",
    postalCode: "Poštanski broj",
    town: "Grad / Mjesto",
    country: "Država",
    selectCountry: "Odaberite državu",

    phone: "Telefonski broj",
    phonePlaceholder: "Telefonski broj",
    phoneCodePlaceholder: "Pozivni broj",
    search: "Traži...",
    noResults: "Nema rezultata",

    terms: "Prihvaćam",
    termsLink: "Uvjete korištenja",
    privacy: "Prihvaćam",
    privacyLink: "Pravila privatnosti",

    save: "Spremi podatke",

    requiredFields: "Molimo ispunite sva obavezna polja.",
    acceptTerms: "Molimo prihvatite uvjete i pravila privatnosti.",
    loginFirst: "Prvo se prijavite.",
    errorSaving: "Greška pri spremanju podataka!",
    errorLoading: "Greška pri učitavanju podataka.",
  },

  password: {
    title: "Promijeni lozinku",
    oldPassword: "Trenutna lozinka",
    newPassword: "Nova lozinka",
    confirmPassword: "Potvrdi novu lozinku",

    cancel: "Odustani",
    save: "Spremi",

    errorInvalid: "Molimo ispunite sva polja ispravno.",
    errorGeneral: "Greška pri promjeni lozinke.",
    success: "Lozinka je uspješno promijenjena.",
    confirmLeave: "Želite li spremiti promjene?",
  },

  impressum: {
    title: "Impressum",
    company: "glampingoase GmbH",
    addressLine1: "Breechliweg 3",
    addressLine2: "5102 Rupperswil",
    country: "Švicarska",

    registryNumber: "Broj registra: CHE-432.303.436",
    registryCourt: "Trgovački registar kantona Aargau",

    emailLabel: "E-mail",
  },

  footer: {
    impressum: "Impressum",
  },

  objectList: {
    title: "Upravljanje dostupnošću i cijenama",
    loading: "Učitavanje...",
    notConfirmed: "još nije potvrđeno",
    editPrices: "Uredi cijene",
    editAvailability: "Uredi dostupnost",
    noObjectsLine1: "Još nema dodanih objekata.",
    noObjectsLine2: "Želite li dodati novi?",
    createObject: "Dodaj novi objekt",
    imageAlt: "Slika objekta",
  },

  prices: {
    openCalendar: "Otvori kalendar",
    datePlaceholder: "dd.mm.gggg",
    object: "Objekt",

    errorFetchCurrency: "Greška pri učitavanju valute",
    errorFetchObjects: "Greška pri učitavanju objekata",
    errorFetchObjectName: "Greška pri učitavanju naziva objekta",
    errorFetchSeasons: "Greška pri učitavanju sezona",
    errorFetchSeasonsAlert: "Došlo je do problema pri učitavanju sezona.",
    errorNotLoggedIn: "Niste prijavljeni.",
    errorMissingFields: "Molimo ispunite sva polja.",
    errorEndBeforeStart: "Datum završetka ne može biti prije datuma početka.",
    errorOverlap: "Ova se sezona preklapa s postojećom sezonom.",

    errorSaveSeason: "Greška pri spremanju sezone",
    errorApiRequest: "Greška pri API zahtjevu",
    errorSaveSeasonAlert: "Došlo je do problema pri spremanju sezone.",

    confirmDeleteSeason: "Želite li izbrisati sezonu",
    errorDeleteSeason: "Greška pri brisanju sezone",
    errorDeleteSeasonAlert: "Sezonu nije moguće izbrisati.",

    errorFinishEditingFirst:
      "Prvo dovršite trenutnu izmjenu prije dodavanja nove sezone.",

    tabPrices: "Cijene",
    tabAdditionalCosts: "Dodatni troškovi",
    tabCurrency: "Valuta",
    tabAvailability: "Dostupnost",
    tabObjectList: "Pregled objekata",

    pricesFor: "Cijene za",

    hidePastSeasons: "Sakrij prošle sezone",
    showPastSeasons: "Prikaži prošle sezone",

    seasonName: "Naziv sezone",
    pricePerNight: "Cijena po noćenju u",

    saving: "Spremanje...",
    cancel: "Odustani",
    addSeason: "+ Dodaj sezonu",

    infoTitle: "Kako unijeti cijene?",

    infoText:
      "Za svaku sezonu definirate razdoblje s datumom početka i završetka.\n\n" +
      "Možete dati bilo koji naziv sezoni. Naziv služi samo za vašu internu organizaciju i nije vidljiv gostima.\n\n" +
      "Cijena se odnosi na noćenje. Pazite da se razdoblja sezona ne preklapaju. Ako se preklapaju, pojavit će se poruka o pogrešci.\n\n" +
      "Kada su svi podaci ispravni, potvrdite zelenom kvačicom. Sezona će biti spremljena i možete dodati novu.\n\n" +
      "Istovremeno se može uređivati samo jedna sezona jer svaka promjena automatski provjerava preklapanja.\n\n" +
      "Već spremljene sezone možete urediti ikonom olovke ili izbrisati ikonom koša. Te su radnje dostupne samo ako trenutno ne uređujete drugu sezonu.\n\n" +
      "Prošle sezone možete prikazati klikom na 'Prikaži prošle sezone'. One su samo informativne i ne mogu se uređivati.",

    close: "Zatvori",

    selectCurrencyTitle: "Odaberite valutu",
    selectCurrencyText: "Molimo odaberite valutu prije dodavanja cijena.",
    currencyRequired: "Prvo odaberite valutu.",

  },

  additionalCosts: {
    title: "Dodatni troškovi za",
    object: "Objekt",

    add: "Dodaj dodatni trošak",

    selectType: "Odaberite vrstu troška",
    selectUnit: "Odaberite jedinicu",
    pricePlaceholder: "Cijena u",

    saving: "Spremanje...",
    cancel: "Odustani",

    finishEditingFirst:
      "Prvo dovršite trenutnu izmjenu prije dodavanja novih troškova.",
    fillAllFields: "Molimo ispunite sva polja.",
    confirmDelete: "Želite li zaista izbrisati ovaj trošak?",

    errorLoadingTypes: "Greška pri učitavanju vrsta troškova",
    errorLoadingUnits: "Greška pri učitavanju jedinica",
    errorLoadingCosts: "Greška pri učitavanju troškova",
    errorSaving: "Greška pri spremanju",
    errorDeleting: "Greška pri brisanju",
  },

  currency: {
    title: "Valuta za",
    select: "Odaberite valutu",
    saving: "Spremanje...",
    save: "Spremi valutu",
    saved: "Valuta uspješno spremljena",
    errorLoadingCurrencies: "Greška pri učitavanju dostupnih valuta",
    errorLoadingObjectCurrency: "Greška pri učitavanju valute objekta",
    errorLoadingObjectName: "Greška pri učitavanju naziva objekta",
    errorSaving: "Greška pri spremanju valute",
    object: "Objekt",
  },

availability: {
  settingsTitle: "Postavke",
  modeTitle: "Način upravljanja dostupnošću",
  modeIcal: "iCal sinkronizacija",
  modeManual: "Ručni unos dostupnosti",

  warningSwitch: "Promjena načina rada izbrisat će postojeće dostupnosti. Želite li nastaviti?",
  saved: "Postavke su spremljene.",

  modalTitle: "Kako želite upravljati svojim dostupnostima?",
  modalText: "Odaberite jednu od dvije opcije. To možete promijeniti u bilo kojem trenutku.",
  chooseIcal: "iCal sinkronizacija",
  chooseManual: "Ručni unos",

  errorLoading: "Pogreška pri učitavanju dostupnosti.",
  tabsAriaLabel: "Kartice dostupnosti",

  tabSettings: "Postavke",
  tabIcal: "Upravljanje iCal-om",
  tabManual: "Unos dostupnosti",
  tabPrices: "Cijene",
  tabObjectList: "Pregled objekata"
},

availabilityManual: {
  editAvailability: "Uredi dostupnost",
  loadingObject: "Učitavanje informacija o objektu…",

  legendAvailable: "Dostupno",
  legendDelete: "Izbriši",

  savedSuccess: "Dostupnosti su uspješno spremljene!",
  savedPartialError: "Neke dostupnosti nije bilo moguće spremiti ili izbrisati.",
  errorSaving: "Pogreška pri spremanju.",
  errorNoObjectId: "Pogreška: ID objekta nije pronađen."
},

availabilityIcal: {
  title: "iCal uvoz",
  loading: "Učitavanje…",

  placeholderUrl: "https://primjer.com/kalendar.ics",
  testPreview: "Testiraj pregled",
  testing: "Testiranje…",
  showSynced: "Prikaži sinkronizirane podatke",

  save: "Spremi",
  saving: "Spremanje...",
  remove: "Ukloni",

  lastSync: "Zadnja sinkronizacija",
  previewFailed: "Pregled nije uspio",
  previewCalendar: "Pregled (kalendar)",

  prev: "Natrag",
  next: "Naprijed",

  errorLoading: "Pogreška pri učitavanju iCal podataka.",
  errorNoUrl: "Nije unesen iCal link.",
  errorPreview: "Došlo je do pogreške pri dohvaćanju linka.",
  errorInvalidUrl: "Nevažeći URL.",
  errorSaving: "Spremanje nije uspjelo.",
  errorRemove: "Uklanjanje nije uspjelo",
  removed: "iCal link je uklonjen",
  saved: "iCal link je spremljen. Sinkronizacija je pokrenuta.",
  errorLoadSynced: "Pogreška pri učitavanju sinkroniziranih podataka.",
  errorNoObjectId: "ID objekta nije pronađen."
},


  newObjectModal: {
    title: "Pronađen nedovršen objekt",
    description:
      "Već ste započeli unos objekta. Želite li nastaviti ili početi ispočetka i prebrisati postojeće podatke?",
    continue: "Nastavi unos",
    startNew: "Započni novi unos",
  },

  object: {
    tabs: [
      "Osnovni podaci",
      "Sobe",
      "Oprema / Okruženje",
      "Kapacitet",
      "Opis",
      "Slike",
      "Predaja"
    ],

    step1: {
      title: "Korak 1: Opće informacije",

      fields: {
        name: "Naziv objekta",
        street: "Ulica",
        house_number: "Kućni broj",
        postal_code: "Poštanski broj",
        city: "Grad",
        object_type: "Vrsta objekta",
        country: "Država",
        region: "Regija",
        licence_number: "Broj licence",
      },

      select: {
        choose: "Odaberite",
      },

      map: {
        info: "Marker se automatski postavlja prema unesenoj adresi. Ako nije točan, možete ga ručno pomaknuti.",
        reset: "Vrati marker na unesenu adresu",
        load_error: "Karta se ne može učitati.",
        loading: "Karta se učitava...",
      },

      geocode: {
        failed: "Geokodiranje nije uspjelo.",
        missing_fields:
          "Molimo ispunite sva polja adrese i provjerite je li Google Maps API učitan.",
      },
    },
      step2: {
        title: "Korak 2: Sobe i oprema",
        addRoom: "Dodaj sobu",
        roomCountTitle: "Koliko soba ima vaš smještaj?",
        roomCountDescription: "Unesite broj za svaku vrstu sobe. Nakon toga možete uređivati svaku sobu pojedinačno.",
        roomCountSharedHint: "Zajedničke prostorije poput kupaonice i kuhinje također se računaju.",
        addAllRooms: "Dodaj sve sobe",
        roomType: "Vrsta sobe",
        amount: "Količina",
        select: "Odaberite",
        usage: "Upotreba",
        private: "Privatna upotreba",
        shared: "Zajednička upotreba",
        onlyOneAllowed: "samo 1 dopušten",

        // Beds
        beds: "Kreveti",
        addBed: "Dodaj krevet",
        bedType: "Vrsta kreveta",
        size: "Veličina",
        sizeWidth: "Širina (cm)",
        sizeLength: "Dužina (cm)",
        sizeOptional: "Opcionalno",
      },

    step3: {
        title: "Korak 3: Oprema i okruženje",
        general: "Opća oprema",
        outdoor: "Vanjska oprema",
        environmentAmenities: "Oprema u okruženju",
        environmentCards: "Okruženje",
        errorLoading: "Pogreška pri učitavanju opreme."
      },
      step4: {
        title: "Korak 4: Kapacitet i opcije kontakta",

        maxOccupancy: "Maksimalni kapacitet",
        maxPets: "Maksimalan broj kućnih ljubimaca",
        minNights: "Minimalan boravak",

        selectPlaceholder: "Odaberite",

        arrivalDays: "Dani dolaska",

        earliestCheckin: "Najraniji check-in",
        latestCheckout: "Najkasniji check-out",

        rules: "Pravila",
        partyAllowed: "Zabave dopuštene",
        smokingAllowed: "Pušenje dopušteno",
        yes: "Da",
        no: "Ne",

        contactOptions: "Opcije kontakta",
        contactHow: "Kako vas gosti trebaju kontaktirati?",
        contactBoth: "Oboje",
        contactWebsite: "Web stranica",
        contactWebsitePlaceholder: "https://example.com",
        contactEmail: "E-mail za kontakt obrazac",

        invalidEmail: "Unesite valjanu adresu e-pošte.",
        errorLoadingArrivalDays: "Pogreška pri učitavanju dana dolaska."
      },
      step5: {
        title: "Korak 5: Opis objekta",
        activitiesTitle: "Aktivnosti u blizini",
        activitiesPlaceholder: "Opišite što se nalazi u blizini vašeg objekta.",
        descriptionTitle: "Opis objekta",
        descriptionPlaceholder: "Unesite jasan tekst koji dobro opisuje objekt."
      },
      step6: {
        title: "Korak 6: Učitavanje slika",

        titleImage: "Naslovna slika",
        additionalImages: "Dodatne slike (maks. 20)",

        selectOrDragTitle: "Odaberite ili povucite naslovnu sliku ovdje",
        dragTitleHere: "Povucite naslovnu sliku ovdje",

        selectOrDragAdditional: "Odaberite datoteke ili ih povucite ovdje",
        dragAdditionalHere: "Povucite dodatne slike ovdje",

        uploaded: "Slika učitana",
        uploadedCount: "{n} slika učitano",

        errorMinSize: "Slika mora biti najmanje {w}x{h} piksela.",
        errorInvalidFormat: "Nevažeći format slike."
      },
      step7: {
        title: "Korak 7: Završetak i odabir pretplate",
        intro: "Gotovo ste gotovi! Odaberite svoj plan i provjerite jesu li svi koraci dovršeni.",

        subscriptionTitle: "Odaberite pretplatu",

        freeTitle: "Free",
        freePrice: "Besplatno",
        freeDescription: "Tekst mjesta. Ovdje ide opis.",

        monthlyTitle: "Mjesečno",
        monthlyPrice: "2 CHF / mjesec",
        monthlyDescription: "Tekst mjesta. Ovdje ide opis.",

        yearlyTitle: "Godišnje",
        yearlyPrice: "20 CHF / godina",
        yearlyDescription: "Tekst mjesta. Ovdje ide opis.",

        overviewTitle: "Pregled vaših podataka",
        fix: "Dovršiti",

        overviewItems: [
          { step: 1, title: "Osnovni podaci" },
          { step: 2, title: "Sobe" },
          { step: 3, title: "Oprema / Okruženje" },
          { step: 4, title: "Kapacitet" },
          { step: 5, title: "Opis" },
          { step: 6, title: "Slike" }
        ],

        errorUnknown: "Nepoznata pogreška.",
        errorGeneral: "Došlo je do pogreške."
      }

  },
};
